'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SocialTiktokOriginalAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.3418 9.21952C17.6279 10.1422 19.2034 10.685 20.9051 10.685V7.39881C20.5831 7.39887 20.2619 7.36517 19.9468 7.29818V9.88491C18.2452 9.88491 16.6699 9.34204 15.3834 8.41947V15.1257C15.3834 18.4805 12.6735 21.1999 9.33081 21.1999C8.08357 21.1999 6.92432 20.8215 5.96133 20.1725C7.06043 21.3003 8.5932 22 10.2889 22C13.6318 22 16.3419 19.2806 16.3419 15.9256V9.21952H16.3418ZM17.524 5.90412C16.8667 5.18348 16.4351 4.25219 16.3418 3.22261V2.79993H15.4336C15.6622 4.10853 16.4419 5.22652 17.524 5.90412ZM8.07558 17.5981C7.70835 17.1149 7.5099 16.5238 7.51079 15.916C7.51079 14.3817 8.75029 13.1376 10.2795 13.1376C10.5645 13.1375 10.8478 13.1813 11.1194 13.2678V9.90811C10.802 9.86445 10.4816 9.84592 10.1614 9.85272V12.4677C9.88965 12.3812 9.60623 12.3373 9.32117 12.3376C7.79195 12.3376 6.55251 13.5815 6.55251 15.1161C6.55251 16.2011 7.17206 17.1405 8.07558 17.5981Z",
          fill: "#FF004F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.3833 8.4194C16.6698 9.34197 18.2452 9.88484 19.9467 9.88484V7.29811C18.9969 7.09508 18.1561 6.59697 17.5239 5.90412C16.4418 5.22645 15.6621 4.10846 15.4335 2.79993H13.048V15.9255C13.0426 17.4556 11.8052 18.6946 10.2793 18.6946C9.3801 18.6946 8.58124 18.2645 8.07531 17.5981C7.17186 17.1405 6.55232 16.2011 6.55232 15.1162C6.55232 13.5817 7.79175 12.3377 9.32097 12.3377C9.61396 12.3377 9.89636 12.3834 10.1613 12.4678V9.85278C6.8773 9.92087 4.23621 12.6137 4.23621 15.9255C4.23621 17.5788 4.8939 19.0775 5.96134 20.1726C6.92433 20.8215 8.08358 21.2 9.33081 21.2C12.6736 21.2 15.3834 18.4804 15.3834 15.1257V8.4194H15.3833Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.9468 7.29817V6.59874C19.0903 6.60005 18.2506 6.35933 17.5239 5.90411C18.1672 6.61089 19.0142 7.09823 19.9468 7.29817ZM15.4335 2.79999C15.4117 2.67493 15.395 2.54904 15.3834 2.42268V2H12.0896V15.1257C12.0844 16.6557 10.8471 17.8947 9.32099 17.8947C8.87296 17.8947 8.44994 17.7879 8.07533 17.5983C8.58126 18.2645 9.38012 18.6946 10.2793 18.6946C11.8051 18.6946 13.0427 17.4558 13.0481 15.9256V2.79999H15.4335ZM10.1614 9.85284V9.10825C9.88619 9.0705 9.60872 9.05155 9.3309 9.05169C5.98789 9.05162 3.27795 11.7712 3.27795 15.1257C3.27795 17.2288 4.34301 19.0822 5.96143 20.1725C4.89399 19.0775 4.23629 17.5787 4.23629 15.9255C4.23629 12.6138 6.87732 9.92093 10.1614 9.85284Z",
          fill: "#00F2EA"
        }
      )
    ]
  }
);
const VpSocialTiktokOriginalAsset = forwardRef(SocialTiktokOriginalAsset);

export { VpSocialTiktokOriginalAsset as default };
